import './LegalPages.css';

import { useEffect } from 'react';

function useLegalMeta(title, path) {
  useEffect(() => {
    document.title = title;
    document.querySelector('link[rel="canonical"]')?.setAttribute('href', `https://www.maisblau.video${path}`);
    window.scrollTo(0, 0);
  }, [title, path]);
}

export function Datenschutz() {
  useLegalMeta('Datenschutzerklärung | mAIsblau Videoproduktion Wien', '/datenschutz');
  return (
    <div className="legal-page" data-testid="datenschutz-page">
      <div className="legal-container">
        <h1>Datenschutzerklärung</h1>
        <p className="last-updated">Stand: {new Date().toLocaleDateString('de-AT')}</p>

        <section>
          <h2>1. Datenschutz auf einen Blick</h2>
          <h3>Allgemeine Hinweise</h3>
          <p>
            Die folgenden Hinweise geben einen einfachen Überblick darüber, was mit Ihren personenbezogenen 
            Daten passiert, wenn Sie diese Website besuchen. Personenbezogene Daten sind alle Daten, mit 
            denen Sie persönlich identifiziert werden können.
          </p>
        </section>

        <section>
          <h2>2. Verantwortliche Stelle</h2>
          <p>
            Verantwortlich für die Datenverarbeitung auf dieser Website ist:
          </p>
          <p className="contact-box">
            <strong>Andreas Hofmarcher</strong><br />
            Gußriegelstraße 8/242<br />
            1100 Wien<br />
            Österreich<br /><br />
            Telefon: +43 681 20179697<br />
            E-Mail: andreas@maisblau.video
          </p>
        </section>

        <section>
          <h2>3. Datenerfassung auf dieser Website</h2>
          
          <h3>3.1 Kontaktformular</h3>
          <p>
            Wenn Sie uns per Kontaktformular Anfragen zukommen lassen, werden Ihre Angaben aus dem 
            Anfrageformular inklusive der von Ihnen dort angegebenen Kontaktdaten zwecks Bearbeitung 
            der Anfrage und für den Fall von Anschlussfragen bei uns gespeichert.
          </p>
          <p><strong>Erfasste Daten:</strong></p>
          <ul>
            <li>Name</li>
            <li>E-Mail-Adresse</li>
            <li>Telefonnummer (optional)</li>
            <li>Firma (optional)</li>
            <li>Projektart (optional)</li>
            <li>Nachricht</li>
            <li>Zeitstempel der Anfrage</li>
          </ul>
          <p><strong>Rechtsgrundlage:</strong> Art. 6 Abs. 1 lit. a DSGVO (Einwilligung) bzw. Art. 6 Abs. 1 lit. b DSGVO (Vertragsanbahnung)</p>
          <p><strong>Speicherdauer:</strong> Ihre Daten werden gelöscht, sobald sie für die Erreichung des Zweckes ihrer Erhebung nicht mehr erforderlich sind. Dies ist in der Regel nach Abschluss der Korrespondenz der Fall.</p>
          <p><strong>Datenempfänger:</strong> Ihre Formulardaten werden per E-Mail an uns versendet (via Resend.com, USA). Es besteht ein Angemessenheitsbeschluss der EU-Kommission.</p>

          <h3>3.2 Fotografie-Galerie</h3>
          <p>
            Auf dieser Website werden Fotografien präsentiert, die von uns erstellt wurden. Die gezeigten Fotos können Personen bei Events, Portraits oder in anderen Situationen darstellen.
          </p>
          <p><strong>Veröffentlichung von Personenfotos:</strong></p>
          <ul>
            <li>Alle abgebildeten Personen haben der Veröffentlichung zugestimmt (Einwilligung nach Art. 6 Abs. 1 lit. a DSGVO bzw. § 78 UrhG)</li>
            <li>Fotos werden ausschließlich zu Portfolio- und Werbezwecken verwendet</li>
            <li>Sollten Sie auf einem Foto abgebildet sein und die Veröffentlichung wünschen zu widerrufen, kontaktieren Sie uns bitte unter andreas@maisblau.video</li>
          </ul>
          <p><strong>Technische Speicherung:</strong> Bilder werden auf sicheren Servern gespeichert und über CDN (Content Delivery Network) ausgeliefert.</p>

          <h3>3.3 Cookies</h3>
          <p>
            Unsere Website verwendet Cookies. Cookies sind kleine Textdateien, die auf Ihrem Endgerät 
            gespeichert werden und die Ihr Browser speichert.
          </p>
          <p><strong>Notwendige Cookies:</strong></p>
          <ul>
            <li><code>cookie-consent</code>: Speichert Ihre Cookie-Präferenz (Dauer: 1 Jahr)</li>
          </ul>
          <p><strong>Analytics-Cookies (nur mit Einwilligung):</strong></p>
          <ul>
            <li>PostHog Analytics Cookies zur Analyse des Nutzerverhaltens</li>
          </ul>
          <p><strong>Rechtsgrundlage:</strong> Art. 6 Abs. 1 lit. a DSGVO (Einwilligung) für Analytics-Cookies</p>

          <h3>3.4 Server-Log-Dateien</h3>
          <p>
            Der Provider der Seiten erhebt und speichert automatisch Informationen in so genannten 
            Server-Log-Dateien:
          </p>
          <ul>
            <li>Browsertyp und Browserversion</li>
            <li>Verwendetes Betriebssystem</li>
            <li>Referrer URL</li>
            <li>Hostname des zugreifenden Rechners</li>
            <li>Uhrzeit der Serveranfrage</li>
            <li>IP-Adresse (anonymisiert)</li>
          </ul>
          <p><strong>Rechtsgrundlage:</strong> Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse an der Sicherheit und Funktionsfähigkeit der Website)</p>
        </section>

        <section>
          <h2>4. Analyse-Tools</h2>
          
          <h3>4.1 PostHog (nur mit Einwilligung)</h3>
          <p>
            Diese Website nutzt PostHog, einen Webanalysedienst, um die Nutzung unserer Website zu 
            analysieren und zu verbessern. PostHog verwendet Cookies und ähnliche Technologien.
          </p>
          <p><strong>Anbieter:</strong> PostHog Inc., USA</p>
          <p><strong>Datenübermittlung:</strong> Es kann zu einer Übermittlung von Daten in die USA kommen. Es besteht ein Angemessenheitsbeschluss der EU-Kommission.</p>
          <p><strong>Rechtsgrundlage:</strong> Art. 6 Abs. 1 lit. a DSGVO (Ihre Einwilligung über den Cookie-Banner)</p>
          <p><strong>Widerruf:</strong> Sie können Ihre Einwilligung jederzeit widerrufen, indem Sie Ihre Browser-Cookies löschen.</p>
        </section>

        <section>
          <h2>5. Eingebettete YouTube-Videos</h2>
          <p>
            Auf dieser Website sind YouTube-Videos eingebettet. Beim Abspielen können Cookies von 
            YouTube gesetzt werden. Wir verwenden den erweiterten Datenschutzmodus von YouTube.
          </p>
          <p><strong>Anbieter:</strong> Google Ireland Limited, Gordon House, Barrow Street, Dublin 4, Irland</p>
          <p><strong>Rechtsgrundlage:</strong> Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse an einer ansprechenden Darstellung unserer Inhalte)</p>
          <p><strong>Datenschutzerklärung:</strong> <a href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer">https://policies.google.com/privacy</a></p>
        </section>

        <section>
          <h2>5a. Google Maps</h2>
          <p>
            Diese Website nutzt den Kartendienst Google Maps zur Darstellung unseres Standorts. 
            Bei der Nutzung von Google Maps werden Daten an Google übertragen, darunter Ihre IP-Adresse 
            und Ihr Standort. Diese Daten werden auf Servern von Google verarbeitet, die sich auch in 
            den USA befinden können.
          </p>
          <p><strong>Anbieter:</strong> Google Ireland Limited, Gordon House, Barrow Street, Dublin 4, Irland</p>
          <p><strong>Zweck:</strong> Darstellung unseres Unternehmensstandorts und Erleichterung der Kontaktaufnahme</p>
          <p><strong>Rechtsgrundlage:</strong> Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse an einer nutzerfreundlichen Standortdarstellung)</p>
          <p><strong>Datenübermittlung:</strong> Es kann zu einer Übermittlung von Daten in die USA kommen. Google nimmt am EU-US Data Privacy Framework teil.</p>
          <p><strong>Datenschutzerklärung:</strong> <a href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer">https://policies.google.com/privacy</a></p>
          <p><strong>Opt-out:</strong> <a href="https://adssettings.google.com/authenticated" target="_blank" rel="noopener noreferrer">https://adssettings.google.com/authenticated</a></p>
        </section>

        <section>
          <h2>5b. WhatsApp-Kontaktbutton</h2>
          <p>
            Auf dieser Website befindet sich ein WhatsApp-Kontaktbutton, der einen externen Link zu 
            WhatsApp (Meta Platforms Ireland Limited) öffnet. Durch das Anklicken des Buttons werden 
            Sie auf die WhatsApp-Plattform weitergeleitet. Wir selbst erfassen dabei keine 
            personenbezogenen Daten. Die Datenverarbeitung durch WhatsApp unterliegt den 
            Datenschutzbestimmungen von Meta.
          </p>
          <p><strong>Anbieter:</strong> Meta Platforms Ireland Limited, 4 Grand Canal Square, Dublin 2, Irland</p>
          <p><strong>Rechtsgrundlage:</strong> Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse an einer einfachen Kontaktmöglichkeit)</p>
          <p><strong>Datenschutzerklärung:</strong> <a href="https://www.whatsapp.com/legal/privacy-policy" target="_blank" rel="noopener noreferrer">https://www.whatsapp.com/legal/privacy-policy</a></p>
        </section>

        <section>
          <h2>5c. Resend (E-Mail-Dienst)</h2>
          <p>
            Für den Versand von E-Mails aus dem Kontaktformular nutzen wir den Dienst Resend. 
            Ihre im Kontaktformular eingegebenen Daten (Name, E-Mail, Telefon, Nachricht) werden 
            über die Server von Resend an uns übermittelt.
          </p>
          <p><strong>Anbieter:</strong> Resend Inc., USA</p>
          <p><strong>Rechtsgrundlage:</strong> Art. 6 Abs. 1 lit. b DSGVO (Vertragsanbahnung) bzw. Art. 6 Abs. 1 lit. a DSGVO (Einwilligung)</p>
          <p><strong>Datenübermittlung:</strong> Es kann zu einer Übermittlung von Daten in die USA kommen. Resend verpflichtet sich zur Einhaltung der DSGVO-Anforderungen.</p>
          <p><strong>Datenschutzerklärung:</strong> <a href="https://resend.com/legal/privacy-policy" target="_blank" rel="noopener noreferrer">https://resend.com/legal/privacy-policy</a></p>
        </section>

        <section>
          <h2>6. Ihre Rechte</h2>
          <p>Sie haben folgende Rechte:</p>
          <ul>
            <li><strong>Auskunftsrecht:</strong> Sie können Auskunft über Ihre gespeicherten Daten verlangen.</li>
            <li><strong>Berichtigungsrecht:</strong> Sie können die Berichtigung unrichtiger Daten verlangen.</li>
            <li><strong>Löschungsrecht:</strong> Sie können die Löschung Ihrer Daten verlangen.</li>
            <li><strong>Einschränkung der Verarbeitung:</strong> Sie können die Einschränkung der Verarbeitung verlangen.</li>
            <li><strong>Datenübertragbarkeit:</strong> Sie können Ihre Daten in einem gängigen Format erhalten.</li>
            <li><strong>Widerspruchsrecht:</strong> Sie können der Verarbeitung Ihrer Daten widersprechen.</li>
            <li><strong>Beschwerderecht:</strong> Sie können sich bei der Datenschutzbehörde beschweren.</li>
          </ul>
          <p>
            <strong>Österreichische Datenschutzbehörde:</strong><br />
            Barichgasse 40-42<br />
            1030 Wien<br />
            Telefon: +43 1 52 152-0<br />
            E-Mail: dsb@dsb.gv.at<br />
            Website: <a href="https://www.dsb.gv.at" target="_blank" rel="noopener noreferrer">www.dsb.gv.at</a>
          </p>
        </section>

        <section>
          <h2>7. Widerruf Ihrer Einwilligung</h2>
          <p>
            Viele Datenverarbeitungsvorgänge sind nur mit Ihrer ausdrücklichen Einwilligung möglich. 
            Sie können eine bereits erteilte Einwilligung jederzeit widerrufen. Die Rechtmäßigkeit der 
            bis zum Widerruf erfolgten Datenverarbeitung bleibt vom Widerruf unberührt.
          </p>
        </section>

        <section>
          <h2>8. SSL- bzw. TLS-Verschlüsselung</h2>
          <p>
            Diese Seite nutzt aus Sicherheitsgründen und zum Schutz der Übertragung vertraulicher Inhalte 
            eine SSL- bzw. TLS-Verschlüsselung. Eine verschlüsselte Verbindung erkennen Sie daran, dass 
            die Adresszeile des Browsers von "http://" auf "https://" wechselt.
          </p>
        </section>

        <div className="legal-footer">
          <a href="/">← Zurück zur Startseite</a>
        </div>
      </div>
    </div>
  );
}

export function Impressum() {
  useLegalMeta('Impressum | mAIsblau Videoproduktion Wien', '/impressum');
  return (
    <div className="legal-page" data-testid="impressum-page">
      <div className="legal-container">
        <h1>Impressum</h1>
        <p className="last-updated">Informationspflicht laut §5 E-Commerce Gesetz, §14 Unternehmensgesetzbuch, §63 Gewerbeordnung und Offenlegungspflicht laut §25 Mediengesetz.</p>

        <section>
          <h2>Diensteanbieter</h2>
          <p className="contact-box">
            <strong>Andreas Hofmarcher</strong><br />
            Einzelunternehmer<br /><br />
            Gußriegelstraße 8/242<br />
            1100 Wien<br />
            Österreich
          </p>
        </section>

        <section>
          <h2>Kontaktdaten</h2>
          <p className="contact-box">
            <strong>Telefon:</strong> <a href="tel:+4368120179697">+43 681 20179697</a><br />
            <strong>E-Mail:</strong> <a href="mailto:andreas@maisblau.video">andreas@maisblau.video</a><br />
            <strong>Website:</strong> <a href="https://www.maisblau.video" target="_blank" rel="noopener noreferrer">www.maisblau.video</a>
          </p>
        </section>

        <section>
          <h2>Unternehmensgegenstand</h2>
          <p>
            AI Videoproduktion, Filmproduktion, Videoproduktion, Video-Porträts, Interviews, 
            Werbespots, Imagefilme, Dokumentationen, TV-Produktionen, Fotografie
          </p>
        </section>

        <section>
          <h2>UID-Nummer</h2>
          <p>ATU70989905</p>
        </section>

        <section>
          <h2>Mitgliedschaft</h2>
          <p>Mitglied der Wirtschaftskammer Österreich (WKO)</p>
        </section>

        <section>
          <h2>Aufsichtsbehörde</h2>
          <p>
            <strong>Magistrat der Stadt Wien</strong><br />
            Magistratisches Bezirksamt für den 10. Bezirk<br />
            Laxenburger Straße 43-47<br />
            1100 Wien
          </p>
        </section>

        <section>
          <h2>Berufsbezeichnung</h2>
          <p>Gewerbeberechtigung: Filmproduktion</p>
        </section>

        <section>
          <h2>EU-Streitschlichtung</h2>
          <p>
            Gemäß Verordnung über Online-Streitbeilegung in Verbraucherangelegenheiten (ODR-Verordnung) 
            möchten wir Sie über die Online-Streitbeilegungsplattform (OS-Plattform) informieren.
          </p>
          <p>
            Verbraucher haben die Möglichkeit, Beschwerden an die Online Streitbeilegungsplattform der 
            Europäischen Kommission unter{' '}
            <a href="https://ec.europa.eu/consumers/odr" target="_blank" rel="noopener noreferrer">
              https://ec.europa.eu/consumers/odr
            </a>{' '}
            zu richten.
          </p>
        </section>

        <section>
          <h2>Haftung für Inhalte dieser Website</h2>
          <p>
            Wir entwickeln die Inhalte dieser Website ständig weiter und bemühen uns korrekte und 
            aktuelle Informationen bereitzustellen. Leider können wir keine Haftung für die Korrektheit 
            aller Inhalte auf dieser Website übernehmen, speziell für jene, die seitens Dritter 
            bereitgestellt wurden.
          </p>
          <p>
            Als Diensteanbieter sind wir gemäß § 17 Abs. 1 ECG für eigene Inhalte, die wir zur Nutzung 
            bereitstellen, nach den allgemeinen Gesetzen verantwortlich.
          </p>
        </section>

        <section>
          <h2>Haftung für Links auf dieser Website</h2>
          <p>
            Unsere Website enthält Links zu anderen Websites für deren Inhalt wir nicht verantwortlich 
            sind. Haftung für verlinkte Websites besteht für uns nicht, da wir keine Kenntnis rechtswidriger 
            Tätigkeiten hatten und haben, uns solche Rechtswidrigkeiten auch bisher nicht aufgefallen sind 
            und wir Links sofort entfernen würden, wenn uns Rechtswidrigkeiten bekannt werden.
          </p>
        </section>

        <section>
          <h2>Urheberrechtshinweis</h2>
          <p>
            Alle Inhalte dieser Website (Bilder, Fotos, Texte, Videos) unterliegen dem Urheberrecht. 
            Falls notwendig, werden wir die unerlaubte Nutzung von Teilen der Inhalte unserer Seite 
            rechtlich verfolgen.
          </p>
        </section>

        <div className="legal-footer">
          <a href="/">← Zurück zur Startseite</a>
        </div>
      </div>
    </div>
  );
}
